import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { createCategory } from '../../actions/categoryAction';
import Axios from '../../axios/axios';
import imageCompression from 'browser-image-compression';


const CreateCategory = () => {
  const dispatch = useDispatch();

  const [name, setName] = useState('');
  const [title, setTitle] = useState('');
  const [priority, setPriority] = useState('');
  const [uploading, setUploading] = useState(false);
  const [photo1, setPhoto1] = useState('');
  const [loading, setLoading] = useState(false);




  const submitHandler = (e) => {
    e.preventDefault();
    setLoading(true)

    dispatch(
      createCategory({
        name,
        title,
        priority,
        photo: photo1
      })
    );
    window.location.href = '/categories';
  };

  const uploadFileHandler = async (e, val) => {
    console.log('uploading');
    const file = e.target.files[0];

    // Set up image compression options
    const options = {
      maxSizeMB: 0.2,
      maxWidthOrHeight: 800,
      useWebWorker: true,
    };

    console.log(file)
    try {

      // Compress the image
      const compressedFile = await imageCompression(file, options);

      const formData = new FormData();
      formData.append('image', compressedFile);
      setUploading(true);


      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      const { data } = await Axios.post('/api/upload', formData, config);
      console.log(data)
      setLoading(false)

      if (val === 'photo1') {
        setPhoto1(data);
      }
      setUploading(false);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };


  return (
    <div className="row">
      <div className="col-12 grid-margin stretch-card ">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Create Category</h4>
            <form className="forms-sample" onSubmit={submitHandler}>
              <div className="form-group">
                <label for="exampleInputName">Category Name</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => setName(e.target.value)}
                  placeholder="name"
                  value={name}
                  required={true}
                />
              </div>

              <div class="form-group">
                <label for="exampleInputName">Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label for="exampleInputPriority4">Photo </label>

                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, 'photo1')}
                // required={true}
                />
              </div>
              <img
                src={
                  photo1 === ''
                    ? process.env.PUBLIC_URL + '/images/select_image.png'
                    : `${photo1}`
                }
                height="150"
                width="50%"
              />
              <div class="form-group">
                <label for="exampleInputPriority4">Priority</label>

                <input
                  type="number"
                  className="form-control"
                  placeholder="Priority"
                  value={priority}
                  onChange={(e) => setPriority(e.target.value)}
                />
              </div>
              <div>
                {loading ? (
                  <div
                    className="spinner-border text-primary"
                    role="status"
                  >
                    <span className="visually-hidden">

                    </span>
                  </div>
                ) : (
                  <div className="bottom-area">
                    <p className="mt-14"></p>
                    <button type="submit" class="btn btn-primary mr-2">
                      Submit
                    </button>
                    <Link to="/categories">
                      <button className="btn btn-light">Canccel</button>
                    </Link>

                  </div>
                )}

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCategory;
